import React, { useState } from "react";
import {
  Box,
  List,
  Divider,
  ListItem,
  Tooltip,
  CssBaseline,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import { MENU_ITEM, SETTINGS } from "../constant/MenuItem";
import { RENTLY_ICON, RENTLY_LOGO } from "../assets";
import { handleLogout } from "../services/api/auth";

import {
  Drawer,
  LogoToolbar,
  LogoImage,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
} from "../styles/SidenavStyles";

function Sidenav() {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer variant="permanent" open={open}>
        <LogoToolbar onClick={() => setOpen(!open)}>
          <LogoImage src={open ? RENTLY_LOGO : RENTLY_ICON} open={open} />
        </LogoToolbar>

        <Divider />

        <List>
          {MENU_ITEM.map((item, index) => {
            const active = isActive(item.redirectTo);
            const IconComponent = active ? item.iconFilled : item.iconOutlined;

            return (
              <Tooltip
                key={index}
                title={!open ? item.title : ""}
                placement="right"
                arrow
              >
                <ListItem disablePadding sx={{ display: "block" }}>
                  <StyledListItemButton
                    active={active}
                    onClick={() => navigate(item.redirectTo)}
                    sx={{
                      justifyContent: open ? "initial" : "center",
                    }}
                  >
                    <StyledListItemIcon
                      active={active}
                      sx={{ mr: open ? 3 : "auto" }}
                    >
                      <IconComponent />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={item.title}
                      open={open}
                      active={active}
                    />
                  </StyledListItemButton>
                </ListItem>
              </Tooltip>
            );
          })}
        </List>

        <Divider sx={{ my: 2 }} />

        <List sx={{ mt: "auto", mb: 1 }}>
          {SETTINGS.map((item, index) => {
            const active =
              item.redirectTo && location.pathname.startsWith(item.redirectTo);
            const IconComponent = active ? item.iconFilled : item.iconOutlined;

            return (
              <Tooltip
                key={index}
                title={!open ? item.title : ""}
                placement="right"
                arrow
              >
                <ListItem disablePadding sx={{ display: "block" }}>
                  <StyledListItemButton
                    active={active}
                    onClick={
                      item.action === "logout"
                        ? () => handleLogout(navigate)
                        : () => navigate(item.redirectTo)
                    }
                    sx={{
                      justifyContent: open ? "initial" : "center",
                    }}
                  >
                    <StyledListItemIcon
                      active={active}
                      sx={{ mr: open ? 3 : "auto" }}
                    >
                      <IconComponent />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={item.title}
                      open={open}
                      active={active}
                    />
                  </StyledListItemButton>
                </ListItem>
              </Tooltip>
            );
          })}
        </List>
      </Drawer>
    </Box>
  );
}

export default Sidenav;
